import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/shared/shared.module';
import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SelectModel } from 'src/tidy-ui-components/components/form/select/select.model';

import { ActivityRow, ActivitySummary } from './activity-row';

/**
 * The list of agent runs shown in the Agents page Activity column and in the
 * narrow-layout Activity side panel. Presentational: the parent loads runs,
 * maps them with toActivityRows() and owns the agent filter and paging. The
 * parent projects its date picker into the filter row.
 */
@Component({
  selector: 'tidy-agent-activity-list',
  standalone: true,
  imports: [CommonModule, IonicModule, SharedModule, TidyUiComponentsModule],
  templateUrl: 'agent-activity-list.component.html',
  styleUrls: ['agent-activity-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentActivityListComponent {

  readonly rows = input<ActivityRow[]>([]);
  readonly loading = input(false);
  readonly loadingMore = input(false);
  /** Every agent the feed can be narrowed to, as dropdown items. */
  readonly agents = input<SelectModel[]>([]);
  /** Name of the agent the feed is narrowed to; empty when it shows every agent. */
  readonly filterName = input('');
  readonly summary = input<ActivitySummary | null>(null);
  readonly canLoadMore = input(false);

  readonly filterChange = output<string>();
  readonly clearFilter = output<void>();
  readonly loadMore = output<void>();
  readonly openRun = output<any>();

  readonly skeletonRows = [1, 2, 3, 4, 5, 6];

  // The dropdown is a picker, not the filter's display (the chip is), so it is
  // rebuilt after each pick to go back to its placeholder.
  readonly pickerKey = signal(0);

  pickAgent(workflowId: string) {
    this.filterChange.emit(workflowId);
    this.pickerKey.update(k => k + 1);
  }
}
